import dayjs from 'dayjs';

// Stored dom is a snapshot from the last GALMLS sync, and that sync only
// re-fetches rows whose ModificationTimestamp advanced in the feed. An ACTIVE
// listing nobody touches in the MLS keeps yesterday's dom forever. Compute
// fresh from dateListed for active rows; trust the stored value for terminal
// statuses (SOLD/EXPIRED/WITHDRAWN), where it's the correct final snapshot.
export function liveDom(input: {
  dom?: number | null;
  dateListed?: Date | string | null;
  isActive?: string | null;
}): number | null {
  if (input.isActive === 'ACTIVE' && input.dateListed) {
    return Math.max(0, dayjs().diff(dayjs(input.dateListed), 'day'));
  }
  return input.dom ?? null;
}
